<template>
  <div class="value-filter">
    <div class="city-parent">
      <div class="city">City</div>
      <div class="buttons-wrapper">
        <div class="buttons7">
          <div class="div4">
            {{ Number(sliderValue[0]) }} - {{ Number(sliderValue[1]) }}
          </div>
          <div class="mpgmpge">{{ mPGMPGe }}</div>
        </div>
      </div>
    </div>
    <div class="range-selector">
      <div class="graph">
        <div
          v-for="index in 96"
          :key="index + 4"
          :class="'graph-child graph-child' + (index + 4)"
        ></div>
      </div>
      <div style="width: 100%">
        <vue-slider
          style="
            padding: 0px 0px;
            width: 100%;
            height: 4px;
            display: flex;
            justify-content: center;
          "
          v-model="sliderValue"
          :dot-options="dotOptions"
          :order="false"
          :tooltip="'none'"
          :min="5"
          :max="100"
          @change="updateGraph"
          @drag-end="checkThumbPosition"
        >
          <template #dot="{ index }">
            <div v-if="index === 0 || index === 1" class="custom-slider-thumb">
              <img
                loading="lazy"
                alt=""
                src="../../assets/custom-slider-icon.svg"
              />
            </div>
          </template>
        </vue-slider>
        <div style="display: flex; justify-content: space-between">
          <span>5</span>
          <span>100</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, defineProps, onMounted } from "vue";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

const props = defineProps({
  mPGMPGe: String,
  min: String,
  max: String,
});

const emits = defineEmits(["citySliderValue"]);
const sliderValue = ref([props.min, props.max]);
const dotOptions = [{ disabled: false, strokeWidth: 1 }, { disabled: false }];

const updateGraph = (value) => {
  const minValue = Math.round(value[0]);
  const maxValue = Math.round(value[1]);

  sliderValue.value = [minValue, maxValue];
  if (props.min != minValue || props.max != maxValue) {
    emits("citySliderValue", sliderValue);
  }

  // Resetting all graph colors to default gray
  const allGraphItems = document.querySelectorAll(".graph-child");
  allGraphItems.forEach((item) => {
    item.style.backgroundColor = "var(--gray-medium)";
  });

  // Marking graph items between min and max as blue
  for (let i = minValue; i <= maxValue; i++) {
    const graphChild = document.querySelector(`.graph-child${i}`);
    if (graphChild)
      graphChild.style.backgroundColor = "var(--primary-accent-base)";
  }
};
const checkThumbPosition = () => {
  // Check if min thumb crosses max thumb
  if (sliderValue.value[0] > sliderValue.value[1]) {
    // Adjust min thumb to be equal to max thumb
    sliderValue.value[0] = sliderValue.value[1] - 5;
    updateGraph(sliderValue.value);
  }
};

onMounted(() => {
  updateGraph(sliderValue.value);
});
</script>

<style scoped>
.custom-slider-thumb {
  position: relative;
  width: 14px;
  height: 14px;
  cursor: pointer;
  justify-content: center;
  display: flex;
}
.city {
  height: 23px;
  width: 80px;
  position: relative;
  letter-spacing: 0.01em;
  line-height: 23px;
  display: inline-block;
  flex-shrink: 0;
}
.div4 {
  align-self: stretch;
  position: relative;
  letter-spacing: 0.01em;
  line-height: 27px;
  font-weight: 600;
  display: inline-block;
}
.mpgmpge {
  height: 21px;
  position: relative;
  font-size: var(--paragraph-primary-medium-regular-size);
  line-height: 21px;
  display: flex;
  align-items: center;
}
.buttons7 {
  flex: 1;
  border-radius: var(--br-9xs);
  background-color: var(--white-light);
  border: 0.5px solid var(--primary-accent-base);
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 2px 15px;
  gap: var(--gap-4xs);
}
.buttons-wrapper {
  height: 33px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
}
.city-parent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  /* padding: 0px var(--padding-102xl) 0px 0px; */
  gap: var(--gap-3xs);
}

.graph-child {
  height: 12px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child1,
.graph-child26,
.graph-child51,
.graph-child76 {
  height: 25px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child2,
.graph-child27,
.graph-child52,
.graph-child77 {
  height: 10px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child3,
.graph-child28,
.graph-child53,
.graph-child78 {
  height: 12px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child4,
.graph-child29,
.graph-child54,
.graph-child79 {
  height: 16px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child5,
.graph-child30,
.graph-child55,
.graph-child80 {
  height: 12px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child6,
.graph-child31,
.graph-child56,
.graph-child81 {
  height: 16px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child7,
.graph-child32,
.graph-child57,
.graph-child82 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child8,
.graph-child33,
.graph-child58,
.graph-child83 {
  height: 6px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child9,
.graph-child34,
.graph-child59,
.graph-child84 {
  height: 6px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}
.graph-child10,
.graph-child35,
.graph-child60,
.graph-child85 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child11,
.graph-child36,
.graph-child61,
.graph-child86 {
  height: 25px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child12,
.graph-child37,
.graph-child62,
.graph-child87 {
  height: 21px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child13,
.graph-child38,
.graph-child63,
.graph-child88 {
  height: 10px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child14,
.graph-child39,
.graph-child64,
.graph-child89 {
  height: 30px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child15,
.graph-child40,
.graph-child65,
.graph-child90 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child16,
.graph-child41,
.graph-child66,
.graph-child91 {
  height: 6px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child17,
.graph-child42,
.graph-child67,
.graph-child92 {
  height: 8px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child18,
.graph-child43,
.graph-child68,
.graph-child93 {
  height: 6px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child19,
.graph-child44,
.graph-child69,
.graph-child94 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child20,
.graph-child45,
.graph-child70,
.graph-child95 {
  height: 8px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child21,
.graph-child46,
.graph-child71,
.graph-child96 {
  height: 26px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child22,
.graph-child47,
.graph-child72,
.graph-child97 {
  height: 26px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child23,
.graph-child48,
.graph-child73,
.graph-child98 {
  height: 4px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child24,
.graph-child49,
.graph-child74,
.graph-child99 {
  height: 8px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph-child25,
.graph-child50,
.graph-child75,
.graph-child100 {
  height: 26px;
  width: 5px;
  position: relative;
  background-color: var(--gray-medium);
}

.graph {
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  gap: var(--gap-11xs);
  width: 100%;
}
.range-selector {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px var(--padding-6xs);
  box-sizing: border-box;
  max-width: 100%;
  text-align: center;
}
.value-filter {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--gap-21xl);
  flex-shrink: 0;
  max-width: 100%;
  text-align: left;
  font-size: var(--paragraph-secondary-large-semibold-size);
  color: var(--black-default);
  font-family: var(--paragraph-secondary-large-semibold);
}

</style>
